import { request } from './request'

//消息首页
export function getNotificationsHome
  () {
  return request({
    url: '/notifications_home',
    method: "get",
  })
}
export function getNotificationsList(type, page) {
  return request({
    url: '/notifications',
    method: "get",
    params: {
      type,
      page
    }
  })
}